import React from 'react';

import { Color } from 'modules/styles/colors';
import { SvgProps } from 'components/UI/Svg/Svg';
import { SNavStyles } from './index';
import { getFillColor, getStrokeColor } from './utils';

export default (props: SvgProps | undefined) => {
  const getFill = getFillColor(
    props?.active,
    props?.activeFillColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );
  const getStroke = getStrokeColor(
    props?.active,
    props?.activeStrokeColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );

  return {
    svg: (
      <g {...SNavStyles}>
        <polygon
          fill={getFill}
          stroke={props?.stroke || getStroke}
          strokeWidth="2px"
          points="18.02,31.13 28.74,31.13 28.74,4.87 24.5,7.73 21.21,4.87 18.02,7.73 14.82,4.87 11.53,7.73 7.29,4.87
  	7.29,31.13 "
        />
        <g {...SNavStyles}>
          <path
            fill={
              props?.fill ||
              props?.color ||
              getFillColor(
                props?.active,
                Color.white,
                props?.disabled,
                Color.grayHue5,
                Color.graySidebarIcon
              )
            }
            stroke="none"
            d="M17.41,20.43 M18.09,16.2l-0.54,0c-0.87,0.07-1.18,0.47-1.18,1.02c0,0.47,0.48,0.73,1.18,0.91l0.73,0.18l0.08,0.02
		l0.5,0.12c1.58,0.41,3.32,1.02,3.32,3.08c0,1.67-1.09,2.97-3.32,3.2l-0.01,1.68h-1.89v-1.72c-1.59-0.14-2.29-0.69-3.12-1.52
		L15,21.52c0.58,0.59,1.39,1.11,2.41,1.29c0,0,0.39,0.05,0.49,0.06c0.1,0,0.45,0,0.45,0c0.86-0.12,1.62-0.6,1.62-1.1
		c0-0.56-0.53-0.82-1.26-1.03L18,20.56l-0.59-0.12c-1.56-0.38-3.26-0.99-3.26-3.03c0-1.55,1.46-2.94,2.66-3.1v-1.73h2.04v1.81
		c1.23,0.12,2.26,0.61,3.08,1.35l-1.2,1.58c-0.53-0.5-1.19-0.79-1.88-0.99c0,0-0.07-0.04-0.38-0.09
		C18.23,16.2,18.09,16.2,18.09,16.2z"
          />
        </g>
      </g>
    ),
    viewBox: '0 0 36 36'
  };
};
